export default {
  loading: false,
  passwordForm: {
    CurrentPassword: '',
    NewPassword: '',
    RepeatNewPassword: '',
  }
}